<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外教招聘</Breadcrumb-item>
        <Breadcrumb-item>注册渠道管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Tabs v-model="activeTab" :animated="false">
      <Tab-pane label="渠道" name="channel">
        <div class="search" @keyup.enter="search">
          <Form :label-width="90" :show-message="false" label-position="right">
            <Row :gutter="24">
              <Col span="6">
                <Form-item label="渠道名称">
                  <Input v-model="queryParam.name" placeholder="支持模糊搜索"></Input>
                </Form-item>
              </Col>
              <Col span="6">
                <Form-item label="渠道参数">
                  <Input v-model="queryParam.param" placeholder="精确匹配"></Input>
                </Form-item>
              </Col>
              <Col span="6">
                <Form-item label="状态">
                  <Select v-model="queryParam.status" placeholder="全部" clearable>
                    <Option :value="1">启用</Option>
                    <Option :value="0">停用</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="6">
                <Form-item>
                  <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
                  <Button type="primary" style="margin-left: 8px" @click="openAdd">新增</Button>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </div>
        <Table :columns="columns" :data="dataList" :loading="tableLoading" border stripe></Table>
        <div style="margin-top: 12px; text-align: right">
          <Page :total="totalCount" :current="queryParam.pageIndex" :page-size="queryParam.pageSize"
                show-total show-sizer @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
        </div>
      </Tab-pane>
      <Tab-pane label="中介" name="agency">
        <div class="search" @keyup.enter="searchAgency">
          <Form :label-width="90" :show-message="false" label-position="right">
            <Row :gutter="24">
              <Col span="5">
                <Form-item label="老师ID">
                  <Input v-model="agencyQuery.id" placeholder="精确" clearable></Input>
                </Form-item>
              </Col>
              <Col span="5">
                <Form-item label="姓名">
                  <Input v-model="agencyQuery.name" placeholder="支持模糊" clearable></Input>
                </Form-item>
              </Col>
              <Col span="5">
                <Form-item label="账号">
                  <Input v-model="agencyQuery.account" placeholder="支持模糊" clearable></Input>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="状态">
                  <Select v-model="agencyQuery.status" placeholder="全部" clearable>
                    <Option v-for="item in $constant.teacherStatus" :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="5">
                <Form-item>
                  <Button type="primary" :loading="agencySearchLoading" @click="searchAgency">查询</Button>
                  <Button type="primary" style="margin-left: 8px" @click="openAgencyAdd">新增</Button>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </div>
        <Table :columns="agencyColumns" :data="agencyList" :loading="agencyTableLoading" border stripe></Table>
        <div style="margin-top: 12px; text-align: right">
          <Page :total="agencyTotal" :current="agencyQuery.pageIndex" :page-size="agencyQuery.pageSize"
                show-total show-sizer @on-change="onAgencyPageChange" @on-page-size-change="onAgencyPageSizeChange"></Page>
        </div>
      </Tab-pane>
    </Tabs>

    <Modal v-model="showModal" :title="formData.id ? '编辑渠道' : '新增渠道'">
      <Form :label-width="90" ref="channelForm" :model="formData">
        <Form-item label="渠道名称" required>
          <Input v-model="formData.name"></Input>
        </Form-item>
        <Form-item label="渠道参数" required>
          <Input v-model="formData.param" :disabled="formData.param === '转介绍' && !!formData.id"></Input>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="showModal=false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="save">确定</Button>
      </div>
    </Modal>

    <tch-info-modal
      v-if="showTchInfoModal"
      :key="'agency-modal-' + (agencyTchId || 'new')"
      :value="showTchInfoModal"
      @on-close="onAgencyModalClose"
      :tchId="agencyTchId"
      :addType="agencyAddType"
      :successCallback="onAgencySaved"
    ></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from './modal/TchInfoModal.vue'

export default {
  name: 'TchRegChannelList',
  components: { TchInfoModal },
  data () {
    let self = this
    return {
      activeTab: 'channel',
      searchLoading: false,
      tableLoading: false,
      saveLoading: false,
      showModal: false,
      totalCount: 0,
      queryParam: {
        name: '',
        param: '',
        status: null,
        pageIndex: 1,
        pageSize: 20
      },
      formData: {
        id: null,
        name: '',
        param: '',
        status: 1
      },
      dataList: [],
      columns: [
        {title: '渠道名称', key: 'name', minWidth: 140},
        {title: '渠道参数', key: 'param', minWidth: 140},
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            const disabled = params.row.param === '转介绍'
            return h('i-switch', {
              props: {
                value: params.row.status === 1,
                disabled: disabled
              },
              on: {
                'on-change': function (val) {
                  self.toggleStatus(params.row, val ? 1 : 0)
                }
              }
            })
          }
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('Button', {
              props: {type: 'primary', size: 'small'},
              on: {
                click: function () {
                  self.openEdit(params.row)
                }
              }
            }, '编辑')
          }
        }
      ],
      agencySearchLoading: false,
      agencyTableLoading: false,
      agencyTotal: 0,
      agencyList: [],
      agencyQuery: {
        id: '',
        name: '',
        account: '',
        status: null,
        pageIndex: 1,
        pageSize: 20
      },
      showTchInfoModal: false,
      agencyTchId: null,
      agencyAddType: 'agency',
      agencyColumns: [
        {title: '老师ID', key: 'id', width: 100},
        {
          title: '姓名',
          minWidth: 160,
          render: (h, params) => {
            const row = params.row || {}
            const full = row.fullName || ''
            const name = ((row.firstName || '') + ' ' + (row.lastName || '')).trim()
            return h('span', full || name || '-')
          }
        },
        {title: '账号', key: 'account', minWidth: 140},
        {
          title: '状态',
          width: 110,
          render: (h, params) => {
            const st = self.$constant.getEnum(self.$constant.teacherStatus, params.row.status)
            return h('span', (st && st.text) || String(params.row.status == null ? '' : params.row.status))
          }
        },
        {
          title: '类型',
          width: 110,
          render: (h) => h('span', '中介老师')
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('Button', {
              props: {type: 'primary', size: 'small'},
              on: {
                click: function () {
                  self.openAgencyEdit(params.row)
                }
              }
            }, '编辑')
          }
        }
      ]
    }
  },
  created: function () {
    this.search()
  },
  watch: {
    activeTab (val) {
      if (val === 'agency' && this.agencyList.length === 0 && !this.agencyTableLoading) {
        this.searchAgency()
      }
    }
  },
  methods: {
    search () {
      let self = this
      self.searchLoading = true
      self.tableLoading = true
      self.queryParam.pageIndex = 1
      this.loadList()
    },
    loadList () {
      let self = this
      this.$http.post('/tch/reg-channel/list', self.queryParam).then(function (res) {
        self.searchLoading = false
        self.tableLoading = false
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || []
          self.totalCount = res.data.totalCount || 0
        }
      }).catch(function () {
        self.searchLoading = false
        self.tableLoading = false
      })
    },
    onPageChange (page) {
      this.queryParam.pageIndex = page
      this.tableLoading = true
      this.loadList()
    },
    onPageSizeChange (size) {
      this.queryParam.pageSize = size
      this.queryParam.pageIndex = 1
      this.tableLoading = true
      this.loadList()
    },
    openAdd () {
      this.formData = {id: null, name: '', param: '', status: 1}
      this.showModal = true
    },
    openEdit (row) {
      this.formData = {
        id: row.id,
        name: row.name,
        param: row.param,
        status: row.status
      }
      this.showModal = true
    },
    save () {
      let self = this
      if (!self.formData.name || !self.formData.param) {
        self.$Message.warning('渠道名称和渠道参数不能为空')
        return
      }
      self.saveLoading = true
      let url = self.formData.id ? '/tch/reg-channel/update' : '/tch/reg-channel/insert'
      this.$http.post(url, self.formData).then(function (res) {
        self.saveLoading = false
        if (res && res.status === 'ok') {
          self.showModal = false
          self.$Message.success('保存成功')
          self.loadList()
        } else {
          self.showModal = true
        }
      }).catch(function () {
        self.saveLoading = false
        self.showModal = true
      })
    },
    toggleStatus (row, status) {
      let self = this
      this.$http.post('/tch/reg-channel/update', {
        id: row.id,
        name: row.name,
        param: row.param,
        status: status
      }).then(function (res) {
        if (res && res.status === 'ok') {
          row.status = status
          self.$Message.success(status === 1 ? '已启用' : '已停用')
        } else {
          self.loadList()
        }
      }).catch(function () {
        self.loadList()
      })
    },
    searchAgency () {
      this.agencyQuery.pageIndex = 1
      this.loadAgencyList()
    },
    buildAgencyParam () {
      const q = this.agencyQuery
      const param = {
        pageIndex: q.pageIndex,
        pageSize: q.pageSize,
        name: q.name || undefined,
        account: q.account || undefined
      }
      if (q.id !== '' && q.id != null) {
        const idNum = parseInt(q.id, 10)
        if (!isNaN(idNum)) {
          param.id = idNum
        }
      }
      if (q.status !== null && q.status !== undefined && q.status !== '') {
        param.status = q.status
      }
      return param
    },
    loadAgencyList () {
      let self = this
      self.agencySearchLoading = true
      self.agencyTableLoading = true
      this.$http.post('/tch/agency/list', self.buildAgencyParam()).then(function (res) {
        self.agencySearchLoading = false
        self.agencyTableLoading = false
        if (res && res.status === 'ok' && res.data) {
          self.agencyList = res.data.data || []
          self.agencyTotal = res.data.totalCount || 0
        }
      }).catch(function () {
        self.agencySearchLoading = false
        self.agencyTableLoading = false
      })
    },
    onAgencyPageChange (page) {
      this.agencyQuery.pageIndex = page
      this.loadAgencyList()
    },
    onAgencyPageSizeChange (size) {
      this.agencyQuery.pageSize = size
      this.agencyQuery.pageIndex = 1
      this.loadAgencyList()
    },
    openAgencyAdd () {
      this.agencyTchId = null
      this.agencyAddType = 'agency'
      this.showTchInfoModal = true
    },
    openAgencyEdit (row) {
      this.agencyAddType = 'agency'
      this.agencyTchId = row.id
      this.showTchInfoModal = true
    },
    onAgencyModalClose () {
      this.showTchInfoModal = false
      this.agencyTchId = null
    },
    onAgencySaved () {
      this.showTchInfoModal = false
      this.agencyTchId = null
      this.loadAgencyList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchRegChannelList.vue?0092ac42